import {Component, EventEmitter, Inject, Input, isDevMode, Output} from '@angular/core';
import {Config} from '../../models/config';
import {FormArray, FormGroup} from '@angular/forms';
import {FindInvalidControlsService} from '../../services/find-invalid-controls.service';
import {IsEditableService} from '../../../order/services/is-editable.service';
import {filter} from 'rxjs/operators';
import {ActionsSubject} from '@ngrx/store';
import {Subscription} from 'rxjs';
import {L10N_LOCALE, L10nLocale} from 'angular-l10n';

@Component({
  selector: 'storever-element-group',
  templateUrl: './element-group.component.html',
  styleUrls: ['./element-group.component.scss']
})
export class ElementGroupComponent {

  errorStatusUpdateText: string;
  @Input() icon: string;
  @Input() title: string;
  @Input() nextSuggestedDate: string;
  @Input() selectOptionDefault: string;
  @Input() form: FormGroup;
  @Input() config: Config[];
  // tslint:disable-next-line:no-any
  @Input() listSelectOption: any[];
  @Input() isAdd: boolean;
  @Input() infoBull: string;
  @Input() tooltipText: string;
  @Input() isEdit: boolean;
  @Input() isExchange: boolean;
  @Input() isLoadingBlock: boolean;
  @Input() status: string;
  @Input() orderType: number;
  @Input() selectOption = false;
  @Input() paramEdit: { text: string, icon: string, type: string, case: string };
  @Input() stylingClass: string;
  @Output() undo: EventEmitter<void> = new EventEmitter<void>();
  // tslint:disable-next-line:no-any
  @Output() selectOptionUpdate: EventEmitter<any> = new EventEmitter<any>();
  @Output() save: EventEmitter<void> = new EventEmitter<void>();
  @Output() emitActions: EventEmitter<boolean | string> = new EventEmitter<boolean | string>();
  @Output() removeOutput: EventEmitter<void> = new EventEmitter<void>();
  private sub$: Subscription;
  private subscriptions = [];

  get getParamsText(): string {
    if (this.paramEdit) {
      return this.paramEdit.text
    }
    return null;
  }

  get getParamsIcon(): string {
    if (this.paramEdit) {
      return this.paramEdit.icon
    }
    return null;
  }

  get isEditable(): boolean {
    if (this.paramEdit.type === 'order') {
      const resp = this.isEditableService.isOrderEditable(this.paramEdit.case, this.status);
      if (!resp) {
        this.errorStatusUpdateText = this.tooltipText ? this.tooltipText : 'ORDER_NOT_ALLOWED_TEXT';
      }
      return resp;
    }
    if (this.paramEdit.type === 'subscription') {
      const resp = this.isEditableService.isSubscriptionEditable(this.paramEdit.case, this.status);
      if (!resp) {
        this.errorStatusUpdateText = this.tooltipText ? this.tooltipText : 'ORDER_NOT_ALLOWED_TEXT';
      }
      return resp;
    }

  }

  constructor(@Inject(L10N_LOCALE) public locale: L10nLocale,
              private findInvalidControlsService: FindInvalidControlsService,
              private isEditableService: IsEditableService,
              private dispatcher: ActionsSubject) {
    this.errorStatusUpdateText = '';
  }

  getInvalidControls(form: FormGroup | FormArray): string[] {
    if (isDevMode()) {
      return this.findInvalidControlsService.find(form);
    }
  }

  get isDisabled(): boolean {
    return this.form.disabled;
  }

  setEdition(): void {
    if (this.paramEdit.icon === 'fal fa-trash-alt') {
      this.removeOutput.emit();
    } else {
      if (this.isEditable) {
      if (this.isShipping) { // TODO: useless and bug for disable for site edition
        this.setEditionShippingAddress();
      } else {
        if (this.form.disabled) {
          this.form.enable({ emitEvent: true });
        } else {
          this.form.disable({ emitEvent: false });
        }
      }
      }
    }
  }

  get isShipping(): boolean {
    if (!this.form.get('addressType')) {
      return false;
    }
    return this.form.get('checkBox') && this.form.get('addressType').value === 'Shipping'
  }

  setEditionShippingAddress(): void {
    if (this.form.disabled) {
      if (this.form.get('checkBox').value === true) {
        this.form.enable({ emitEvent: true });
        this.form.get('checkBox').patchValue(false);
      } else {
        this.form.enable({ emitEvent: true });
      }
    } else {
      this.form.disable({ emitEvent: false });
    }
  }

  undoEdition(): void {
    this.setEdition();
    this.form.markAsPristine();
    this.undo.emit();
  }

  saveEdition(): void {
    if (this.form.valid && this.form.dirty) {
      this.save.emit();
      this.sub$ = this.dispatcher.pipe(
        filter(action => action.type === '[orders] Patch Success')
      ).subscribe(() => {
        this.form.disable();
      });
      this.subscriptions.push(this.sub$);
    }
  }

  resetOrDisableFormDataFromList(action: string, form: FormGroup, path: string[]): void {
    path.forEach(field => {
      const control = form.get(field);
      if (action === 'reset') {
        control.reset();
      } else if (action === 'disable') {
        control.disable({ emitEvent: false })
      } else if (action === 'enable') {
        control.enable({ emitEvent: false })
      }
    });
  }
  // tslint:disable-next-line:no-any
  selectOptionUp(value: any): void {
    this.selectOptionUpdate.emit(value);
  }
}
